import * as React from 'react'
import { FC } from 'react'

import { ManageDefaultsFormWrapper } from './ManageDefaultsFormWrapper'
import { SideDrawer } from '@sales-center/components'

interface Props {
  onClose: () => void
  open: boolean
}

export const ManageDefaultsDrawer: FC<Props> = (props) => {
  const { onClose, open } = props

  return (
    <SideDrawer
      onClose={onClose}
      open={open}
      title="Default Sales Teams"
      width={550}
    >
      <ManageDefaultsFormWrapper onClose={onClose} />
    </SideDrawer>
  )
}

ManageDefaultsDrawer.displayName = 'ManageDefaultsDrawer'
